import React from 'react';
import { isNil } from 'lodash';
import { Row, Col } from 'antd';

import {
  AssignmentAdditionalInfoModel,
  AssignmentAdminAdditionalInfoModel,
} from 'api/backofficeApiClient';
import { formatNumberAsCurrency } from 'utils/numberUtils';

import styles from '../../AssignmentDetailsPage.module.less';

type Props = {
  additionalInfo: AssignmentAdminAdditionalInfoModel &
    AssignmentAdditionalInfoModel;
};

export default function AssignmentAdditionalInfoCard(props: Props) {
  const { additionalInfo } = props;

  return (
    <Row gutter={[4, 4]} className="titled-sheet">
      {additionalInfo && (
        <>
          {!isNil(additionalInfo.markup) && (
            <Col xs={24} md={12} data-id="assignmentAdditionalInfoMarkup">
              <div className="title">Markup:</div>
              <div>
                {formatNumberAsCurrency({
                  num: additionalInfo.markup,
                  symbol: '%',
                  isRightSymbol: false,
                })}
              </div>
            </Col>
          )}

          {!isNil(additionalInfo.grossMarginPerHour) && (
            <Col
              xs={24}
              md={12}
              data-id="assignmentAdditionalInfoGrossMarginPerHour"
            >
              <div className="title">Gross margin/hr:</div>
              <div>
                {formatNumberAsCurrency({
                  num: additionalInfo.grossMarginPerHour,
                })}
              </div>
            </Col>
          )}

          {!isNil(additionalInfo.grossMarginPercent) && (
            <Col
              xs={24}
              md={12}
              data-id="assignmentAdditionalInfoGrossMarginPercent"
            >
              <div className="title">Gross margin %:</div>
              <div>
                {formatNumberAsCurrency({
                  num: additionalInfo.grossMarginPercent,
                  symbol: '%',
                  isRightSymbol: false,
                })}
              </div>
            </Col>
          )}

          {!isNil(additionalInfo.anticipatedWeeklyCommission) && (
            <Col
              xs={24}
              md={12}
              data-id="assignmentAdditionalInfoAnticipatedWeeklyCommission"
            >
              <div className="title">Anticipated commission:</div>
              <div>
                {formatNumberAsCurrency({
                  num: additionalInfo.anticipatedWeeklyCommission,
                })}
              </div>
            </Col>
          )}

          {additionalInfo.confirmationCommissionStructure && (
            <Col
              xs={24}
              data-id="assignmentAdditionalInfoConfirmationCommissionStructure"
            >
              <div className={styles.note}>
                <span className="icon icon-check-outlined" />
                <span>Commission structure confirmed.</span>
              </div>
            </Col>
          )}
        </>
      )}
    </Row>
  );
}
